import React from 'react';
import { Link as RouterLink } from "react-router-dom";
import {
  Container,
  Box,
  Typography,
  Link,
  Divider,
  Grid,
  IconButton,
  Paper
} from '@mui/material';
import {
  LinkedIn,
  Instagram,
  Twitter,
  Email,
  LocationOn,
  Phone
} from '@mui/icons-material';
import { grey } from '@mui/material/colors';

const Footer = () => {
  return (
    <Paper 
      component="footer" 
      elevation={3}
      sx={{ 
        mt: 8,
        py: 6,
        backgroundColor: grey[900],
        color: 'white'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Social Media Links */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              Connect With Us
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <IconButton 
                href="https://linkedin.com/company/nsfscooterlab" 
                target="_blank"
                rel="noopener"
                sx={{ 
                  color: 'white',
                  backgroundColor: '#0077B5',
                  '&:hover': { backgroundColor: '#006097' }
                }}
              >
                <LinkedIn />
              </IconButton>
              <IconButton 
                href="https://instagram.com/nsfscooterlab/" 
                target="_blank"
                rel="noopener"
                sx={{ 
                  color: 'white',
                  background: 'linear-gradient(45deg, #405DE6, #5851DB, #833AB4, #C13584, #E1306C, #FD1D1D)',
                  '&:hover': { opacity: 0.9 }
                }}
              >
                <Instagram />
              </IconButton>
              <IconButton 
                href="https://twitter.com/thescooterlab" 
                target="_blank"
                rel="noopener"
                sx={{ 
                  color: 'white',
                  backgroundColor: '#1DA1F2',
                  '&:hover': { backgroundColor: '#1991db' }
                }}
              >
                <Twitter />
              </IconButton>
            </Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Follow us for updates and announcements
            </Typography>
          </Grid>

          {/* Contact Information */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              Contact Information
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <LocationOn sx={{ mr: 1 }} />
              <Typography variant="body2">
                <Link 
                  href="https://maps.google.com?q=506+Dolorosa+St,+San+Antonio,+TX+78204" 
                  target="_blank"
                  rel="noopener"
                  color="inherit"
                  underline="hover"
                >
                  ScooterLab<br />
                  506 Dolorosa St<br />
                  San Antonio, TX 78204, USA
                </Link>
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Email sx={{ mr: 1 }} />
              <Link 
                href="mailto:scooterlab@utsa.edu" 
                color="inherit"
                underline="hover"
                variant="body2"
              >
                scooterlab@utsa.edu
              </Link>
            </Box>
          </Grid>

          {/* Quick Links */}
          {/* <Grid item xs={12} md={4}>
          <Link component={RouterLink} to="/dashboard" color="inherit" underline="hover" display="block" mb={1}>Dashboard</Link>
            <Link component={RouterLink} to="/rental" color="inherit" underline="hover" display="block" mb={1}>Rentals</Link>
            <Link component={RouterLink} to="/userstats" color="inherit" underline="hover" display="block" mb={1}>Stats</Link>
            <Link component={RouterLink} to="/precautions" color="inherit" underline="hover" display="block" mb={1}>Safety Precautions</Link>

          </Grid> */}
        </Grid>

        <Divider sx={{ my: 4, backgroundColor: grey[700] }} />

        <Typography variant="body2" align="center">
          © {new Date().getFullYear()} ScooterLab UTSA. All rights reserved.
        </Typography>
      </Container>
    </Paper>
  );
};

export default Footer;